import React, { Component } from "react";
import styled from "styled-components";
import { DefaultInput } from "@alboompro/boom-components/data-entry/input/";
import BoomCheckbox from "@alboompro/boom-components/data-entry/checkbox/";
import EditorLabel from "editor/components/EditorLabel";
import Switch from "./SwitchComponent/Switch";
import { PropListItem, PropLabel } from "./styles";

const CustomListItem = styled(PropListItem)`
  flex-direction: column;
  align-items: flex-start;
  > div {
    flex: 1;
    width: 100%;
  }
`;

const LabelContent = styled.div`
  display: flex;
`;

const LinkOptions = styled.div`
  padding-top: 10px;
  > div {
    &:first-child {
      margin-bottom: 0;
      padding-bottom: 10px;
    }
  }
`;

const TargetBlank = styled.div`
  display: flex;
`;

class Link extends Component {
  constructor() {
    super();

    this.state = {
      value: "",
      enabled: false
    };
  }

  componentDidMount() {
    const { enabled, input } = this.props;
    this.setState({
      value: input.defaultValue,
      enabled
    });
  }

  toggleLinkSwitch = () => {
    const { enabled } = this.state;

    if (enabled) {
      this.setState({
        value: "",
        enabled: false
      });
    } else {
      this.setState({
        enabled: true
      });
    }
  };

  render() {
    const {
      label,
      input,
      name,
      locale,
      updaterFn,
      currentValue,
      tooltip
    } = this.props;
    const { value, enabled } = this.state;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <CustomListItem>
        <LabelContent>
          <PropLabel>
            <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
          </PropLabel>
          <Switch value={enabled} onClick={this.toggleLinkSwitch} />
        </LabelContent>
        {enabled && (
          <LinkOptions>
            <DefaultInput
              name={name}
              label={input.label[locale]}
              inputStyle={{ fontSize: "12px", padding: "8px 10px" }}
              labelStyle={{
                fontSize: "12px",
                lineHeight: "normal",
                marginBottom: "3px"
              }}
              value={value}
              onChange={e => {
                this.setState({ value: e.target.value });
              }}
            />
            <TargetBlank>
              <BoomCheckbox
                onChange={() => updaterFn({ prop: name, value: !currentValue })}
                label={label[locale]}
                checked={currentValue}
                style={{ marginBottom: 10 }}
                labelStyle={{ fontSize: 10 }}
              />
            </TargetBlank>
          </LinkOptions>
        )}
      </CustomListItem>
    );
  }
}

export default Link;
